import { make } from "vuex-pathify"

const state = {
    isLoading: false,
    page: {
        data: [],
        meta: {
            total: 0,
            current_page: 1,
            last_page: 1
        }
    },
    form: {}
}

const mutations = make.mutations(state)

const actions = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
